import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { FileUpload } from '../../../common/formElements/FileUpload';
import showAlert from '../../../common/utils/alert';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import CustomJSCDNForm from './CustomJSCDNForm';
import ListCustomJSCDNs from './ListCustomJSCDNs';
import { toast } from 'react-toastify';
import JsEditor from '../JsEditor';
import ToggleButton from '../../../common/ui/ToggleButton';

export const CustomJsCdn = ({
  projectId,
  version,
  projectDetail,
  actions,
  showCustomJSCDNLoader,
  appSetting,
  deleteFlag,
}) => {
  const [toggle, setToggle] = useState(false);
  const [isJsCdnCreate, setIsJsCdnCreate] = useState(true);
  const [isNewCustomJSCdn, setIsNewCustomJSCdn] = useState(false);
  const [isUpdateCustomJSCdn, setIsUpdateCustomJSCdn] = useState(false);
  const [customJsCdnUuid, setCustomJsCdnUuid] = useState('');
  const [copied, setCopied] = useState('');

  const { customJsCdns, toggleUnloadDefaultJS, loadAllJsCdnToBuilder } = projectDetail;
  const loadDefaultJS = !toggleUnloadDefaultJS;
  const loadAllJsToBuilderCanvas = loadAllJsCdnToBuilder;

  const handleCustomJsCdnDelete = (uuid) => {
    const preConfirm = () => {
      actions.deleteProjectCustomJsCdn({ projectId, version, uuid });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  const handleCustomJsCdnSubmit = (values) => {
    if (values && values.uuid) {
      actions.updateProjectCustomJsCdn({
        projectId,
        version,
        uuid: values.uuid,
        data: values,
      });
    } else {
      actions.addProjectCustomJsCdn({
        projectId,
        version,
        data: values,
      });
    }
  };

  const handleUnloadDefaultJquery = () => {
    const text = loadDefaultJS
      ? 'You are removing the default jQuery. It may have unknown effect on the project.'
      : 'Loading default jQuery on the project.';
    const preConfirm = () => {
      actions.toggleProjectDefaultJs({ projectId, version, data: {} });
    };
    showAlert(
      text,
      preConfirm,
      loadDefaultJS ? 'Yes, unload it!' : 'Yes, load it!',
      loadDefaultJS ? 'warning' : 'info',
    );
  };

  const handleUnloadAllJSFromBuilder = () => {
    const text = loadAllJsToBuilderCanvas
      ? 'You are unloading all the URL/Tags from Builder Canvas.'
      : 'Enable loading of URL/Tags to Builder Canvas.';
    const preConfirm = () => {
      actions.toggleProjectJsCdnsFromBuilder({ projectId, version, data: {} });
    };
    showAlert(
      text,
      preConfirm,
      loadAllJsToBuilderCanvas ? 'Yes, unload it!' : 'Yes, load it!',
      loadAllJsToBuilderCanvas ? 'warning' : 'info',
    );
  };

  const copyToClipboard = (urlOrTag) => {
    setCopied(urlOrTag);
    toast.success('Copied to clipboard');
    setTimeout(() => {
      setCopied('');
    }, 2000);
  };

  return (
    <>
      <Modal isOpen={toggle} toggle={() => setToggle(false)} backdrop="static">
        <ModalHeader toggle={() => setToggle(false)} className="border-bottom">
          <strong>Upload Custom JS</strong>
        </ModalHeader>
        <ModalBody className="d-flex flex-column justify-content-center align-items-center">
          <FileUpload
            url={`${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/custom-js-cdn/file`}
            projectId={projectId}
            version={version}
            maxFiles={1}
            maxSizeBytes="20971520"
            accept="text/javascript"
            fileIcon="customJS"
            submitAction={() => actions.loadCustomJsCdns({ version, projectId })}
          />
        </ModalBody>
      </Modal>
      <ParentCardNoCol
        title="Add JavaScript URL/Script Tag"
        bgColor="drapcode-violet"
        icon="customJSCDN"
        CtaComponent={
          <div className="form-group">
            <ToggleButton
              name="loadAllJsCdnToBuilder"
              title="Load All to Builder Canvas"
              text="Load All to Builder Canvas"
              onChange={handleUnloadAllJSFromBuilder}
              isChecked={loadAllJsToBuilderCanvas}
            />
            <ToggleButton
              name="unloadDefaultJs"
              title="Load Default jQuery (Default: True)"
              text="Load Default jQuery"
              onChange={handleUnloadDefaultJquery}
              isChecked={loadDefaultJS}
            />
            <button className="btn btn-theme-submit btn-md" onClick={() => setToggle(true)}>
              <i className="wb webconnect-cloud-arrow-up-fill"></i>&nbsp;Upload JS&nbsp;
            </button>
            &nbsp;
            <button
              type="button"
              className="btn btn-theme-submit btn-md"
              onClick={() => {
                setIsNewCustomJSCdn(true);
                setIsJsCdnCreate(true);
                setCustomJsCdnUuid('');
              }}
            >
              <i className={`wb ${drapcodeIcon('add')}`}></i> Add JS URL/Script Tag&nbsp;
            </button>
          </div>
        }
      >
        {(isNewCustomJSCdn || isUpdateCustomJSCdn) && (
          <CustomJSCDNForm
            customJsCdns={customJsCdns}
            handleCustomJsCdnSubmit={handleCustomJsCdnSubmit}
            showCustomJSCDNLoader={showCustomJSCDNLoader}
            closeNewCustomJsCdn={() => {
              setIsNewCustomJSCdn(false);
              setIsUpdateCustomJSCdn(false);
              setIsJsCdnCreate(true);
            }}
            isJsCdnCreate={isJsCdnCreate}
            customJsCdnUuid={customJsCdnUuid}
          />
        )}
        {customJsCdns && customJsCdns.length > 0 && (
          <ListCustomJSCDNs
            projectId={projectId}
            projectDetail={projectDetail}
            customJsCdns={customJsCdns}
            handleCustomJsCdnDelete={handleCustomJsCdnDelete}
            actions={actions}
            deleteFlag={deleteFlag}
            copyToClipboard={copyToClipboard}
            openCustomJSCDNForm={(uuid) => {
              setIsUpdateCustomJSCdn(true);
              setIsJsCdnCreate(false);
              setCustomJsCdnUuid(uuid);
            }}
          />
        )}
      </ParentCardNoCol>
      {appSetting.jsuuid && !appSetting.fetchJsEditorDataPending && (
        <Modal
          isOpen={appSetting.isOpenJsEditorModal}
          toggle={() => {
            actions.toggleJsEditorModal();
          }}
          backdrop="static"
          style={{ maxWidth: '70%', marginTop: '70px' }}
        >
          <ModalHeader
            toggle={() => {
              actions.toggleJsEditorModal();
            }}
            className="border-bottom"
          >
            <strong>View/Edit JS</strong>
          </ModalHeader>
          <ModalBody>
            <JsEditor projectId={projectId} appSetting={appSetting} version={version} />
          </ModalBody>
        </Modal>
      )}
    </>
  );
};
